import React from "react";
import { AppBar, Toolbar, Typography, Button, Box, Link } from "@mui/material";

const Navbar = () => {
    return (
        <AppBar position="static" sx={{ backgroundColor: "#4A90E2" }}>
            <Toolbar>
                <Typography variant="h6" sx={{ flexGrow: 1 }}>
                    CrystalCompanion
                </Typography>
                <Box>
                    <Button color="inherit" component={Link} href="/">
                        Home
                    </Button>
                    <Button color="inherit" component={Link} href="/quiz">
                        Quiz
                    </Button>
                    <Button color="inherit" component={Link} href="/shop">
                        Shop
                    </Button>
                    <Button color="inherit" component={Link} href="/about">
                        About
                    </Button>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Navbar;
